import { TReduxActions } from 'shared/map-search/actions';
import { EResultsActionType } from 'shared/map-search/actions/results';

import type { TPromoPinConfig } from 'shared/map-search/utils/ymapsModules/PinPulseManager';

/**
 * @todo разработка в MNZ-700
 * Новый редюсер для конфигурации пинов промо-слоя
 */
const initialState: TPromoPinConfig = {
  promoPinsEnabled: false,
  activeZoomPin: 9,
  duration: 3200,
  activeZoomBalloon: 6,
  activeZoomBalloonDetails: 17,
  pulseRadius: 7,
};

export const promoPinConfig = (state = initialState, action: TReduxActions) => {
  switch (action.type) {
    case EResultsActionType.Succeed: {
      return {
        ...state,
        promoPinsEnabled: action.payload?.isPromotionTopPulsedGlowEnabled ?? state.promoPinsEnabled,
      };
    }

    default:
      return state;
  }
};
